import React from 'react';
import { connect } from 'react-redux';

// Aliased: the module also exports the unconnected component under its own name.
import ConnectedAssignMultipleRecords from '../../components/modal/AssignMultipleRecords';
import { getDocumentStatuses, getUserDepartmentsByQuery } from '../../actions/userProfile';
import { assignDocumentsBulk, archiveReceivedRecords, bulkAssignSettled } from '../../actions/records';
import { rowSelected } from '../../actions/inboxTableActions';

// No markDocumentAsCompleted here: bulk assign has no Mark Complete and Reassign
// mode, which is the one thing AssignRecordDialog wires that this does not.
const AssignMultipleRecordsDialog = (props) => <ConnectedAssignMultipleRecords {...props} />;

export default connect(
  (state) => ({
    aiTag: state.auth.data.aiTag,
  }),
  {
    assignDocumentsBulk,
    archiveReceivedRecords,
    getDocumentStatuses,
    getUserDepartmentsByQuery,
    refreshInboxAfterAssign: bulkAssignSettled,
    rowSelected,
  },
)(AssignMultipleRecordsDialog);
